import Component from '../inherited/Component'
import datepicker from 'js-datepicker'
import AjaxApi from '../lib/AjaxApi'
import axios from 'axios'
import Queue from '../lib/Queue'

export default class DeliveryDatePicker extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._postcodeButton = this._elem.querySelector('[data-postcode-button]')
    this._postcodeInput = this._elem.querySelector('[data-postcode-input]')
    this._postcodeExcluded = this._elem.querySelectorAll('[data-postcode-excluded]')
    this._postcodeError = this._elem.querySelectorAll('[data-postcode-error]')
    this._postcodeSuccess = this._elem.querySelectorAll('[data-postcode-success]')
    this._datePickerInput = this._elem.querySelector('[data-date-picker-input]')
    this._datePickerLabel = this._elem.querySelector('[data-date-picker-label]')
    this._mainCartForm = document.querySelector('#my-ajax-cart-form')

    this._checkoutButton = document.querySelector('#CartDrawer-Checkout')
    this._htmlElem = document.querySelector('html')

    this._data = JSON.parse(
      this._elem.querySelector('[data-delivery-date-picker-data]')?.innerHTML
    )
    this._postcodeExclusions = this._data.postcodeExclusions
    this._extraDayPostcodes = this._data.extraDayPostcodes
    this._blackoutDates = this._data.blackout

    this._currentDate = new Date()
    this._minDate = this._currentDate
    this._blackoutAdded = false
    this._dateSelected = this._convertDate(this._datePickerInput.value)

    this._queue = new Queue()

    this._queue.onEmpty(() => {
      this._checkoutButton?.classList.remove('loading')
      this._htmlElem.classList.remove('js-ajax-cart-processing')
    })
  }

  unmount() {
    if(this._datePicker) {
      this._datePicker.remove()
    }
  }

  async mount() {

    if(!this._data) return

    this._updateCartAttributes({ 'Delivery Date': '' })
    this._elem.querySelector('#delivery-date').value = ''


    if(!window.deliveryDateListeners) {

      this._ctx.on('radiant--cart-update', cart => {
        this._reInit()
      })

      document.addEventListener('liquid-ajax-cart:request-end', event => {
        this._reInit()
      })

      window.deliveryDateListeners = true

    }

    if(!this._options.disable) {
      this._elem.classList.remove('hide')
      this._datePickerInit()

      this._postcodeInput.addEventListener('keyup', e => {
        this._postcodeInput.value = this._postcodeInput.value.toLocaleUpperCase()
        this._postcodeError.forEach(error => error.classList.add('hide'))
        this._postcodeSuccess.forEach(success => success.classList.add('hide'))
      })
      this._postcodeButton.addEventListener('click', e => {
        this._postcodeCheck()
      })
    } else {
      this._elem.classList.add('hide')
    }
  }

  async _postcodeCheck() {
    let postcodeEntered = this._elem
      .querySelector('[data-postcode-input]')
      .value.replace(/\s+/g, '')
    let substringNum = postcodeEntered.length - 3
    let postcodePrefix = postcodeEntered.substring(0, substringNum)
    let postcodeRegex = /^[A-Z]{1,2}[0-9RCHNQ][0-9A-Z]?\s?[0-9][ABD-HJLNP-UW-Z]{2}$|^[A-Z]{2}-?[0-9]{4}$/

    let validPostcode = true
    let excludedPostcode = false
    for (let i = 0; i < this._postcodeExclusions.length; i++) {
      let excluded = this._postcodeExclusions[i].split('*')[0]
      if(excluded.length < 3) {
        // excluding whole postcode area
        let postcodeArea = postcodePrefix.substring(0, excluded.length)
        if(excluded == postcodeArea) {
          excludedPostcode = true
          validPostcode = false
          break
        }
      } else {
        if (excluded == postcodePrefix) {
          excludedPostcode = true
          validPostcode = false
          break
        }
      }
    }

    if(!postcodeRegex.test(postcodeEntered)) {
      validPostcode = false
    }

    if (validPostcode) {
      this._updateCartAttributes({ 'Postcode': postcodeEntered })
      this._postcodeExcluded.forEach(exclusion => exclusion.classList.add('hide'))
      this._postcodeSuccess.forEach(success => success.classList.remove('hide'))
      this._postcodeError.forEach(error => error.classList.add('hide'))

      let extraDayNeeded = false

      for (let i = 0; i < this._extraDayPostcodes.length; i++) {
        if (this._extraDayPostcodes[i] == postcodePrefix) {
          let currentDate = new Date()
          currentDate = new Date(
            currentDate.setDate(
              currentDate.getDate() + this._data.daysToOffset
            )
          )
          currentDate.setDate(this._minDate.getDate() + 1)
          this._datePicker.setMin(currentDate)

          extraDayNeeded = true
          break
        }
      }

      if (!extraDayNeeded) {
        this._datePicker.setMin(this._minDate)
      } 

      this._elem
        .querySelector('.qs-datepicker-container')
        .classList.add('is-active')
    } else {
      if(excludedPostcode) {
        this._updateCartAttributes({ 'Postcode': postcodeEntered })

        this._postcodeExcluded.forEach(exclusion => exclusion.classList.remove('hide'))
        this._postcodeSuccess.forEach(success => success.classList.add('hide'))
        this._postcodeError.forEach(error => error.classList.add('hide'))
      } else {
        this._updateCartAttributes({ 'Delivery Date': '', 'Postcode': '', 'minDate': '' })
        this._postcodeExcluded.forEach(exclusion => exclusion.classList.add('hide'))
        this._postcodeSuccess.forEach(success => success.classList.add('hide'))
        this._postcodeError.forEach(error => error.classList.remove('hide'))
      }
      this._elem
        .querySelector('.qs-datepicker-container')
        .classList.remove('is-active')
      
      this._elem.querySelector('#delivery-date').value = ''
    }
  }

  async _datePickerInit() {
    let datesToDisable = []

    for (let j = 0; j < this._blackoutDates.length; j++) {
      datesToDisable.push(this._convertDate(this._blackoutDates[j]))
    }

    this._currentDate = new Date(
      this._currentDate.setDate(
        this._currentDate.getDate() + this._data.daysToOffset
      )
    )

    this._minDate = this._currentDate


    for (let lead = 0; lead < this._data.globalLeadTime; lead++) {
      this._minDate.setDate(this._minDate.getDate() + 1)
      if(this._minDate.getDay() === 0) {
        this._minDate.setDate(this._minDate.getDate() + 1)
      }
      if(this._minDate.getDay() === 6) {
        this._minDate.setDate(this._minDate.getDate() + 2)
      }

      if(this._blackoutDates.includes(this._minDate.toLocaleDateString('en-GB'))) {
        this._minDate.setDate(this._minDate.getDate() + 1)
      }
    }

    console.log('after global', this._minDate)

    for (let productLead = 0; productLead < this._data.daysToAdd; productLead++) {
      this._minDate.setDate(this._minDate.getDate() + 1)
      if(this._minDate.getDay() === 0) {
        this._minDate.setDate(this._minDate.getDate() + 1)
      }
      if(this._minDate.getDay() === 6) {
        this._minDate.setDate(this._minDate.getDate() + 2)
      }

      if(this._blackoutDates.includes(this._minDate.toLocaleDateString('en-GB'))) {
        this._minDate.setDate(this._minDate.getDate() + 1)
      }
    }

    console.log('after product', this._minDate)
    
    this._currentHour = this._minDate.getHours()
    if (this._currentHour >= this._data.cutOffTime) {
      this._minDate.setDate(this._minDate.getDate() + 1)
    }

    if (this._dateSelected < this._minDate) {
      this._updateCartAttributes({ 'Delivery Date': '' })
      this._datePickerInput.value = ''
      this._dateSelected = ''
    }

    if(this._minDate.getDay() === 0) {
      this._minDate.setDate(this._minDate.getDate() + 1)
    }

    if(this._minDate.getDay() === 6) {
      this._minDate.setDate(this._minDate.getDate() + 2)
    }

    this._updateCartAttributes({ 'minDate': this._minDate.toLocaleDateString('en-GB') })

    this._datePicker = datepicker(this._datePickerInput, {
      disabler: date =>
        (this._currentDate.getDay() === 7 && date.getDay() === 1) ||
        (this._currentDate.getDay() === 7 && date.getDay() === 2),
      formatter: (input, date) => {
        const value = date.toLocaleDateString('en-GB')
        input.value = value
      },
      onSelect: (_instance, date) => {
        if (date !== undefined) {
          // a date has been chosen, we can allow checkout
          const selectedDate = date.toLocaleDateString('en-GB')
          this._updateCartAttributes({ 'Delivery Date': selectedDate })
          this._elem.querySelector('#delivery-date').value = selectedDate
        } else {
          this._updateCartAttributes({ 'Delivery Date': ''})
          this._elem.querySelector('#delivery-date').value = ''
        }
      },
      noWeekends: true,
      position: 'tl',
      startDay: 1,
      alwaysShow: true,
      startDate: this._minDate,
      minDate: this._minDate,
      maxDate: this._convertDate(this._data.maxDate),
      disabledDates: datesToDisable,
      disableYearOverlay: true,
      dateSelected: this._dateSelected,
    })
  }

  _convertDate(date) {
    if (date) {
      let splitDate = date.split('/')
      let month = splitDate[1] - 1
      return new Date(splitDate[2], month, splitDate[0])
    } else {
      return
    }
  }
 
  async _updateCartAttributes(attributes) {
    try {
      this._checkoutButton?.classList.add('loading')
      this._htmlElem.classList.add('js-ajax-cart-processing')
      
      this._queue.add(async () => {
        await AjaxApi.updateCart({
          attributes: attributes,
        })
      })
    } catch (e) {
      console.error('ERROR', e)
      console.error(e.response.data)
      alert(e.response.data.description)
      this._checkoutButton?.classList.remove('loading')
      this._htmlElem.classList.remove('js-ajax-cart-processing')
    } finally {
    }
  }

  async _reInit() {
    let toWaitFor = axios.get(window.location.pathname)
    let resp = await toWaitFor
    let parser = new DOMParser()
    let html = parser.parseFromString(resp.data, 'text/html')
    let fetchedElem = html.querySelector('[data-delivery-date-picker]')
    document.querySelector('[data-delivery-date-picker]').replaceWith(fetchedElem)
    this._theme.mountComponents(document.body)
  }
}
